module.exports = __webpack_public_path__ + "static/media/user.14128e69.png";